export const checkDealRentingProductInAllowedRentingProducts = (
    allowedRentingProducts: string,
    dealRentingProduct: string
): boolean => {
    const parsedRentingProducts = allowedRentingProducts?.split(',');
    return parsedRentingProducts.includes(dealRentingProduct);
};
